<template>
  <el-select
    v-model="vendorId"
    filterable
    remote
    :clearable="clearable"
    :placeholder="placeholder"
    :remote-method="remoteMethod"
    :loading="loading"
    @change="handleChange">
    <el-option
      v-for="item in options"
      :key="item.vendorId"
      :label="item.vendorName"
      :value="item.vendorId">
    </el-option>
  </el-select>
</template>
<script>
import Common from '@/service/common'
export default {
  name: 'EntRemoteSelect',
  props: {
    value: { required: true },
    placeholder: { type: String, default: '请输入企业名称' },
    clearable: { type: Boolean, default: true }
  },
  data() {
    return { loading: false, options: [] }
  },
  computed: {
    vendorId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleChange() {
      this.$emit('change')
    },
    setInitValue(options = []) {
      this.options = options
    },
    remoteMethod(query) {
      if (query) {
        this.loading = true
        Common.getvendors({ pageNum: 1, pageSize: 100, vendorName: query, memberFlag: 1 })
          .then(res => {
            this.loading = false
            const { result, message, records } = res.data
            if ([0, 13].includes(result)) {
              this.options = records
            } else {
              console.log(message)
              // this.$message.error(message)
            }
          })
          .catch(err => {
            this.loading = false
            console.log(err)
            // this.$message.error(err.message)
          })
      }
    }
  }
}
</script>
